import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Radio } from '@dossierhq/design';
export function SchemaIndexEditor({ indexDraft }) {
    // const canChangeIndex = indexDraft.status === 'new';
    return (_jsxs(Field, { children: [_jsx(Field.Label, { children: "Index type" }), _jsx(Field.Control, { children: _jsx(Radio, { name: "type", checked: true, children: indexDraft.type }) })] }));
}
//# sourceMappingURL=SchemaIndexEditor.js.map